import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import React from "react";
import PipeCard from "../../../pipe-common/PipeCard";
import {convertMainOutputControlToBoolean} from "./IndicatorHelper";
import {formatToExponential} from "../../../../helpers/NumberHelper";

const defaultIndicators = {
    mainOutputControl: false,
    currentSetPoint: "---",
    voltageSetPoint: "---",
    outputCurrent: "---",
    outputVoltage: "---"
};

export default function SorensenXgReadBack({pipe, data}) {
    const indicators = data
        ? Object.assign(defaultIndicators, {
            mainOutputControl: convertMainOutputControlToBoolean(data["main_output_control"]),
            currentSetPoint: data["current_set_point"],
            voltageSetPoint: data["voltage_set_point"],
            outputCurrent: data["output_current"],
            outputVoltage: data["output_voltage"]
        }) : defaultIndicators;

    return (
        <PipeCard
            title={pipe.title}
            status={"INACTIVE"}
            content={
                <Grid container direction={"column"} alignItems={"center"} spacing={2}>
                    <Grid item xs={12}>
                        <FormControl>
                            <FormGroup row>
                                <FormControlLabel
                                    value="main_output_control"
                                    control={
                                        <Switch readOnly={true} checked={indicators.mainOutputControl}/>
                                    }
                                    label={
                                        <Typography style={{fontSize: "0.9rem"}}>
                                            Main Output Control
                                        </Typography>
                                    }
                                />
                            </FormGroup>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} container
                          spacing={2}
                          direction={"row"}
                          justify={"center"}
                          alignItems={"center"}
                    >
                        <Grid item>
                            <TextField
                                id="current-set-point"
                                label="Current Set Point"
                                value={formatToExponential(indicators.currentSetPoint)}
                                inputProps={{
                                    readOnly: true,
                                    style: {textAlign: "center"}
                                }}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                id="voltage-set-point"
                                label="Voltage Set Point"
                                value={formatToExponential(indicators.voltageSetPoint)}
                                inputProps={{
                                    readOnly: true,
                                    style: {textAlign: "center"}
                                }}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                id="output-current"
                                label="Output Current"
                                value={formatToExponential(indicators.outputCurrent)}
                                inputProps={{
                                    readOnly: true,
                                    style: {textAlign: "center"}
                                }}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                id="output-voltage"
                                label="Output Voltage"
                                value={formatToExponential(indicators.outputVoltage)}
                                inputProps={{
                                    readOnly: true,
                                    style: {textAlign: "center"}
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            }
        />
    );
}